import Vue from 'vue';
import VueRouter from 'vue-router';
import manageRoutes from '@/router/manage';
import NotFound from '@/views/NotFound';

Vue.use(VueRouter);

const routes = [
  ...manageRoutes,
  {
    // will match everything
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
